export enum ExternalLinkMissionScreenOutKeys {
  NO_REDIRECT = 'external_link.no_redirect.mission.ScreenedOut',
  REDIRECT = 'external_link.mission.ScreenedOut',
  INVALID_LEGAL_QUESTION = 'missionTransfer.InvalidLegalQuestion'
}
